import { render } from "./Newest.vue?vue&type=template&id=d452c16c"
import script from "./Newest.vue?vue&type=script&lang=js"
export * from "./Newest.vue?vue&type=script&lang=js"

import "./Newest.vue?vue&type=style&index=0&id=d452c16c&lang=scss"

import exportComponent from "/var/www/www-root/data/www/malmarket/malmarket-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__